import { TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';

import { FilteringListBox } from './FilteringListBox';

export function ManageDataAlertRecipientsDialogBody(props: FilteringListBox.Props<IUser>): JSX.Element {
  const DIALOG_BODY_ID = 'manage-data-alert-recipients-dialog-body';
  return <div>
    <div id={DIALOG_BODY_ID} style={{ marginBottom: TabStyles.Spacing.MediumSpace }}>{Messages.dataAlertRecipientDialogDescription()}</div>
    <FilteringListBox aria-labelledby={DIALOG_BODY_ID} {...props} />
  </div>;
}
